<template>
  <div>
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.spare-parts.list.filter.label')"
            />
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
        <div v-if="!hideFilters" class="table-block q-mb-md">
        <div class="row q-pa-md" style="justify-content: space-between;">
            <div class="col-6 q-pa-md">
            <q-input color="primary"
                v-model="filters.name"
                @input="applyFilters"
                :float-label="getString('name') + ' pdf'"/>
            </div>
        </div>
        <div class="row q-pa-md" style="justify-content: space-between">
          <div class="q-pa-md" style="vertical-align: middle">
            <q-btn
              :disable="!activeFilters"
              @click="resetFilters()"
              class="capitalize ctrl-button"
              :color="activeFilters ? 'primary' : 'grey-4'"
              label="Reset"
            />
          </div>
        </div>
      </div>
    </transition>

    <table-overview
      endpoint="spareparts/pdf"
      :responseFormat="'spare_part_pdf'"
      :columns="columns"
      permission="spare-parts"
      module="spare-parts"
      :selectable="false"
      :custom-events="true"
      @click="onRowClicked"
    >
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import moment from 'moment';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [filtersMixin],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      module: 'spare-parts',
      permission: 'spareparts',
      columns: [
        {
          name: '__slot:spareparts-name',
          title: getString('module.spare-parts.field.pdfName'),
          sortField: 'names',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: '__slot:spareparts-reference',
          title: getString('module.spare-parts.field.serviceReference'),
          sortField: 'references',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
          callback: 'getPdfName',
        },
        {
          name: 'processed_at.date',
          title: getString('datetime.label'),
          sortField: 'processed_at',
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
          callback: 'tableFormatTime',
        },
        {
          name: '__slot:spareparts-reference-score',
          title: getString(null, 'Reference score', 'Referentie score'),
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
        },
        {
          name: '__slot:spareparts-checked',
          title: 'Checked',
          sortField: 'check_status',
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
        },
        {
          name: '__slot:spareparts-activated',
          title: 'Activated',
          sortField: 'activated',
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
        },
      ],
      filters: {
        name: '',
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  methods: {
    getString,
    onRowClicked(data) {
      const row = data.row;
      if (row.process_status === 'PROCESS_FAILED') {
        const action = row.error
          ? [{
            label: getString('module.spare-parts.part.overview.see-logs'),
            handler: () => this.$router.push(`/spare-part-logs/${row.error}`),
          }]
          : null;
        this.notify(
          getString('module.spare-parts.part.overview.failed'),
          action,
        );
        return;
      }
      if (row.will_be_processed) {
        const message = this.getString(
          'module.spare-parts.part.overview.toBeProcessed',
        );
        this.notify(
          message.replace('%date%', moment(row.will_be_processed.date).format('DD-MM-YYYY'))
            .replace('%time%', moment(row.will_be_processed.date).format('HH:mm')),
        );
        return;
      }
      if (
        this.$store.state.meStore.me.rights.includes(
          `${this.permission}.edit`,
        )
        || this.$store.state.meStore.me.su
      ) {
        this.$router.push(`/${this.module}/${row.id}`);
      }
    },
    notify(message, actions = []) {
      this.$q.notify({
        message,
        position: 'top-right',
        timeout: 6000,
        color: 'warning',
        actions,
      });
    },
  },
  computed: {
    checkboxActive() {
      return this.filters.active ? 'primary' : 'grey-4';
    },
  },
};
</script>

<style lang="stylus">
@import '~variables';

.pdf-status {
  display: flex;

  &__indicate {
    margin: 0 5px;
    width: 20px;
    min-width: 20px;
    height: 20px;
    background-color: $ctrl-grey-lighten-1;
    border-radius: 50%;
    display: block;

    &--green {
      background-color: $ctrl-turquoise;
    }

    &--red {
      background-color: $ctrl-red;
    }

    &--blue {
      background-color: $ctrl-blue;
    }
  }
}
</style>
